module.exports = __webpack_public_path__ + "img/行业的专业咨询bg@2x.4c26b810.png";